var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDollar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 23V28",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 53V58",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M40 70.5C56.5685 70.5 70 57.0685 70 40.5C70 23.9315 56.5685 10.5 40 10.5C23.4315 10.5 10 23.9315 10 40.5C10 57.0685 23.4315 70.5 40 70.5Z",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 53H43.75C45.4076 53 46.9973 52.3415 48.1694 51.1694C49.3415 49.9973 50 48.4076 50 46.75C50 45.0924 49.3415 43.5027 48.1694 42.3306C46.9973 41.1585 45.4076 40.5 43.75 40.5H36.25C34.5924 40.5 33.0027 39.8415 31.8306 38.6694C30.6585 37.4973 30 35.9076 30 34.25C30 32.5924 30.6585 31.0027 31.8306 29.8306C33.0027 28.6585 34.5924 28 36.25 28H47.5",
    stroke: "white",
    strokeWidth: 5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDollar);
export default __webpack_public_path__ + "static/media/dollar.faaa42392b15989b65285034b0da3dfe.svg";
export { ForwardRef as ReactComponent };